import { z } from 'zod';
// =============================================================================
// ENUMS
// =============================================================================
export const ChargeType = { FLAT: 'FLAT', PERCENTAGE: 'PERCENTAGE' };
export const ChargeOperation = { ADD: 'ADD', SUBTRACT: 'SUBTRACT' };
export const ChargeDisplayMode = { LINE_ITEM: 'LINE_ITEM', GROUPED: 'GROUPED' };
// =============================================================================
// CHARGE TEMPLATE SCHEMA
// Represents the API response for GET/POST/PATCH/DELETE /admin/charges/templates
// =============================================================================
export const chargeTemplateSchema = z.object({
    id: z.number().int().positive(),
    name: z.string().min(1),
    type: z.enum(['FLAT', 'PERCENTAGE']),
    amount: z.number().min(0),
    operation: z.enum(['ADD', 'SUBTRACT']),
    is_active: z.boolean(),
    display_mode: z.enum(['LINE_ITEM', 'GROUPED']).default('LINE_ITEM'),
    is_mandatory: z.boolean().default(true),
    compounds_percentage: z.boolean().default(false),
    created_at: z.string(),
    updated_at: z.string(),
});
// =============================================================================
// CREATE / UPDATE SCHEMAS (for form validation)
// =============================================================================
export const createChargeTemplateSchema = z.object({
    name: z
        .string()
        .min(2, 'El nombre debe tener al menos 2 caracteres')
        .max(60, 'El nombre no puede superar los 60 caracteres'),
    type: z.enum(['FLAT', 'PERCENTAGE'], { required_error: 'El tipo es requerido' }),
    amount: z
        .number({ required_error: 'El monto es requerido', invalid_type_error: 'El monto debe ser un número' })
        .min(0, 'El monto no puede ser negativo'),
    display_mode: z.enum(['LINE_ITEM', 'GROUPED']).default('LINE_ITEM'),
    is_mandatory: z.boolean().default(true),
    compounds_percentage: z.boolean().default(false),
});
